// Home page entry — countdown, hero patch, app assembly, mount.
const { useState, useEffect } = React;

// EDITMODE-persisted defaults
const TWEAK_DEFAULTS = /*EDITMODE-BEGIN*/{
  "palette": "lavender",
  "fonts": "cormorant",
  "hero": "centered",
  "sectionOrder": [
    "schedule",
    "venue",
    "travel",
    "faq"
  ]
}/*EDITMODE-END*/;

const SECTIONS = {
  schedule: () => <Schedule />,
  venue: (p) => <Venue palette={p} />,
  travel: () => <Travel />,
  rsvp: () => <RsvpTeaser />,
  faq: () => <Faq />,
};

function paletteTokens(p) {
  return {
    cream: p.cream, ink: p.ink, wisteria: p.wisteria, olive: p.olive,
  };
}

function Countdown() {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 60_000);
    return () => clearInterval(id);
  }, []);
  const target = new Date('2027-04-10T15:00:00+02:00').getTime();
  const diff = Math.max(0, target - now);
  const d = Math.floor(diff / 86400_000);
  const h = Math.floor((diff % 86400_000) / 3600_000);
  const m = Math.floor((diff % 3600_000) / 60_000);
  return (
    <div className="hero-counter">
      <div className="hero-counter__cell"><span className="hero-counter__num">{d}</span><span>jours</span></div>
      <div className="hero-counter__cell"><span className="hero-counter__num">{h}</span><span>heures</span></div>
      <div className="hero-counter__cell"><span className="hero-counter__num">{m}</span><span>minutes</span></div>
    </div>
  );
}

// Patch Hero to inject countdown into centered variant
const OriginalHero = window.Hero;
window.Hero = (props) => {
  const h = OriginalHero(props);
  if (props.layout !== 'centered') return h;
  // Replace the #countdown placeholder by cloning tree — simpler: render custom centered hero
  return (
    <section className="hero hero--centered" data-screen-label="Hero">
      <div className="hero-canopy" aria-hidden="true" />
      <CornerFlourish className="hero-corner hero-corner--bl" stroke={props.palette.olive} accent={props.palette.wisteria} />
      <CornerFlourish className="hero-corner hero-corner--br" stroke={props.palette.olive} accent={props.palette.wisteria} flip />
      <div className="hero-inner">
        <h1 className="hero-names">
          Naïla <em className="amp">&amp;</em> Fabrice
        </h1>
        <div className="hero-bigdate">Samedi 10 avril 2027</div>
        <Divider color={props.palette.olive} accent={props.palette.wisteria} />
        <p className="hero-sub">
          Nous serions ravis de vous accueillir<br/>
          au <strong>Hameau de Valouse</strong>, en Drôme provençale,<br/>
          pour célébrer notre mariage.
        </p>
        <Countdown />
      </div>
    </section>
  );
};

function App() {
  const [state, setState] = useState(TWEAK_DEFAULTS);

  useEffect(() => { applyPalette(PALETTES[state.palette]); }, [state.palette]);
  useEffect(() => { applyFonts(FONT_PAIRS[state.fonts]); }, [state.fonts]);

  const palette = paletteTokens(PALETTES[state.palette]);

  return (
    <>
      <Hero layout={state.hero} palette={palette} />
      {state.sectionOrder.map(key => (
        <React.Fragment key={key}>{SECTIONS[key](palette)}</React.Fragment>
      ))}
      <Footer palette={palette} />
      <TweaksPanel state={state} setState={setState} />
    </>
  );
}

// apply immediately to avoid flash
applyPalette(PALETTES[TWEAK_DEFAULTS.palette]);
applyFonts(FONT_PAIRS[TWEAK_DEFAULTS.fonts]);

ReactDOM.createRoot(document.getElementById('app')).render(<App />);
